import { render, staticRenderFns } from "./FeaturesTable.vue?vue&type=template&id=d22fdffc&scoped=true"
import script from "./FeaturesTable.vue?vue&type=script&lang=js"
export * from "./FeaturesTable.vue?vue&type=script&lang=js"
import style0 from "./FeaturesTable.vue?vue&type=style&index=0&id=d22fdffc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d22fdffc",
  null
  
)

export default component.exports